import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { facetedSearch } from "./Reducers/FacetedSearch.reducer";
import { myPage } from './Reducers/MyPage.reducer';
import { checkout } from "./Reducers/Checkout.reducer";
import { lightboxImages } from './Reducers/LightboxImages.reducer';
import { notification } from './Reducers/Notification.reducer';
import { selectOrganization } from './Reducers/SelectOrganization.reducer';
import { createBusinessCard } from './Reducers/CreateBusinessCard.reducer';
import { dropZone } from './Reducers/DropZone.reducer';
import { dynamicForms } from './Reducers/DynamicForm.reducer';
import { formStatus } from './Reducers/FormStatus.reducer';

const app = combineReducers({
    cart,
    checkout,
    quickSearch,
    navigation,
    myPage,
    facetedSearch,
    lightboxImages,
    notification,
    selectOrganization,
    createBusinessCard,
    dropZone,
    dynamicForms,
    formStatus
});

export default app;